import PromoBanners from './promos/promo-banners';

declare global {
    interface Window {
        saitPromoBanners: any;
     }
}

const globalPromosInit = function () {
    // global js functions
    window.saitPromoBanners = new PromoBanners();
}
globalPromosInit();